import { Injectable } from "@angular/core";
import { BackendHttpClient, DefaultResponseData } from "@api/http";
import { Observable } from "rxjs";

export interface EburyConnectStartResponse {
  authorization_url: string;
}

export interface EburyConnectionResponse {
  status: "connected" | "disconnected" | "error";
  connected_at: string | null;
  expires_at: string | null;
  scope: string | null;
  last_error: string | null;
  connected_by_user_id: number | null;
}

export interface EburyClient {
  id: string;
  name: string;
  status: string;
  brand: string;
}

export interface EburyClientMapping {
  id: number;
  client_id: number;
  ebury_client_id: string;
  ebury_client_name: string | null;
}

export interface EburyClientMappingShow {
  client_id: number;
  mapped: boolean;
  mapping: EburyClientMapping | null;
}

@Injectable({
  providedIn: "root",
})
export class EburyService {
  constructor(private http: BackendHttpClient) {}

  startConnect(): Observable<DefaultResponseData<EburyConnectStartResponse>> {
    return this.http.get<DefaultResponseData<EburyConnectStartResponse>>(
      "payouts/ebury/connect/start"
    );
  }

  getConnection(): Observable<DefaultResponseData<EburyConnectionResponse>> {
    return this.http.get<DefaultResponseData<EburyConnectionResponse>>(
      "payouts/ebury/connection"
    );
  }

  getClients(): Observable<DefaultResponseData<EburyClient[]>> {
    return this.http.get<DefaultResponseData<EburyClient[]>>(
      "payouts/ebury/clients"
    );
  }

  getClientMapping(
    clientId: number
  ): Observable<DefaultResponseData<EburyClientMappingShow>> {
    return this.http.get<DefaultResponseData<EburyClientMappingShow>>(
      `payouts/ebury/mappings/${clientId}`
    );
  }

  upsertClientMapping(
    clientId: number,
    eburyClientId: string | null
  ): Observable<DefaultResponseData<EburyClientMappingShow>> {
    return this.http.put<DefaultResponseData<EburyClientMappingShow>>(
      `payouts/ebury/mappings/${clientId}`,
      { ebury_client_id: eburyClientId }
    );
  }
}
